<template>
  <div style="padding-left:10px">
    <div>
      <el-form label-position='right' :model="ruleForm" ref="ruleForm" label-width="130px" class="demo-ruleForm">
        <el-form-item label="自动生成月账单:" prop="executionFlag" :rules="[
      { required: true, message: '自动生成月账单不能为空'},
    ]">
          <el-radio-group v-model="ruleForm.executionFlag" :disabled="disabledChange">
            <el-radio label="1">是</el-radio>
            <el-radio label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <div style="display:flex;">
          <el-form-item label="月账单开始日:" prop="startDay" :rules="[
      { required: true, message: '月账单开始日为空'},
    ]">
            <el-select style="width: 80px" :disabled="disabledChange" v-model="ruleForm.startDay" size="mini"
              placeholder="请选择" filterable>
              <el-option v-for="(item, index) in startData" :key="index" :label="item" :value="item">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item style="margin-left:50px;" label="月账单生成日:" prop="executionDay" :rules="[
      { required: true, message: '月账单生成日不能为空'},
    ]">
            <el-select style="width: 80px" :disabled="disabledChange" v-model="ruleForm.executionDay" size="mini"
              placeholder="请选择" filterable>
              <el-option v-for="(item, index) in generateData" :key="index" :label="item" :value="item">
              </el-option>
            </el-select>
          </el-form-item>
        </div>
        <div style="margin-left:-100px">
          <el-form-item label="">
            <p style="color:red">提示：账期默认为1个月，月账单生成日不能早于账单结束日</p>
          </el-form-item>
          <el-form-item label="">
            <el-button type="primary" size="mini" @click="change" v-if="btnFlg[1]&&buttonChange">修改</el-button>
            <el-button type="primary" size="mini" @click="baocun('ruleForm')" v-if="btnFlg[1]&&!buttonChange">保存
            </el-button> 

          </el-form-item>
        </div>

      </el-form>
    </div>

  </div>
</template>

<script>
  import {
    getBtn
  } from '@/utils/getButton'
  import DonMessage from '@/utils/message'

  import {
    getTMonthlyStatementConfig,
    getTMonthlyStatementConfigAdd,
    getTMonthlyStatementConfigUpdate,
  } from '@/api/wms-stock'
  export default {
    data() {
      return {
        disabledChange: true,
        buttonChange: true,
        ruleForm: {
          executionFlag: '0',
          startDay: '1',
          executionDay: '1',
        },
        startData: [],
        generateData: [],
        activeName: 'first',
        btnFlg: [],
        btnIdArr: [
          '003M3X0100',
          '003M3X0200',
        ]
      }
    },
    methods: {
      chongzhi() {
        this.startData = []
        this.generateData = []
        for (let i = 1; i < 28; i++) {
          this.startData[i] = i
        }
        for (let i = 1; i < 29; i++) {
          this.generateData[i] = i
        }
        this.startData = this.startData.filter(Boolean);
        this.generateData = this.generateData.filter(Boolean);
        console.log(this.startData, 'this.startData')
        this.getTMonthlyStatementConfigS()
      },
      change() {
        this.disabledChange = false
        this.buttonChange = false
      },
      baocun(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {

            if (this.ruleForm.startDay > this.ruleForm.executionDay) {
              DonMessage.error('月账单生成日不能小于开始日')

            } else {
              const loading = this.$loading({
                lock: true,
                text: '正在处理...'
              })
              if (!this.ruleForm.configId) {
                // 新增
                getTMonthlyStatementConfigAdd({
                    ...this.ruleForm
                  })
                  .then((res) => {
                    DonMessage.success('操作成功')
                    this.disabledChange = true
                    this.buttonChange = true
                    this.getTMonthlyStatementConfigS()
                    loading.close()
                  })
                  .catch((err) => {
                    DonMessage.error(err.message)
                    loading.close()
                  })
              } else {
                // 修改 
                getTMonthlyStatementConfigUpdate({
                    ...this.ruleForm
                  })
                  .then((res) => {
                    DonMessage.success('操作成功')
                    this.disabledChange = true
                    this.buttonChange = true
                    this.getTMonthlyStatementConfigS()
                    loading.close()
                  })
                  .catch((err) => {
                    DonMessage.error(err.message)
                    loading.close()
                  })
              }
            }

          } else {
            console.log('error submit!!');
            return false;
          }
        });

      },

      getTMonthlyStatementConfigS() {
        getTMonthlyStatementConfig({})
          .then((res) => {
            if (res !== null) {
              this.$set(this.ruleForm, 'configId', res.configId)
              this.$set(this.ruleForm, 'executionFlag', res.executionFlag)
              this.$set(this.ruleForm, 'startDay', res.startDay)
              this.$set(this.ruleForm, 'executionDay', res.executionDay)
            } else {
              this.$set(this.ruleForm, 'executionFlag', '0')
              this.$set(this.ruleForm, 'startDay', '1')
              this.$set(this.ruleForm, 'executionDay', '1')
            }
          })
          .catch((err) => {
            DonMessage.error(err.message)
          })
      }
    },

    mounted() {
      this.btnFlg = getBtn(this.btnIdArr, '/settlementSettings')
      this.startData = []
      this.generateData = []
      for (let i = 1; i < 28; i++) {
        this.startData[i] = i
      }
      for (let i = 1; i < 29; i++) {
        this.generateData[i] = i
      }
      this.startData = this.startData.filter(Boolean);
      this.generateData = this.generateData.filter(Boolean);
      this.getTMonthlyStatementConfigS()


    }
  }

</script>

<style lang="less" scoped>
  .inpBox {
    .el-form-item {
      margin-left: 10px;
      margin-bottom: 0px;
    }
  }

  /deep/.el-table th.star div::before {
    content: '*' !important;
    color: red !important;
  }

</style>
